import script from "./selectRow.vue?vue&type=script&setup=true&lang=js"
export * from "./selectRow.vue?vue&type=script&setup=true&lang=js"

import "./selectRow.vue?vue&type=style&index=0&id=420c12b2&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420c12b2"]])

export default __exports__